import "./async_form.js";

if (document.querySelector("[c-file-upload]")) {
	import("./fileupload.js");
}
